import actionTypes from '@atom/actions/actionTypes';

import initialState from './initialState';

export default function mediaTotalReducer(
  state = initialState.mediaTotal,
  action,
) {
  switch (action.type) {
    case actionTypes.GET_MEDIA_TOTAL_SUCCESS: {
      return action.data ? action.data : 0;
    }
    case actionTypes.DELETE_MEDIA_SUCCESS: {
      return state > 0 ? state - 1 : state;
    }
    default: {
      return state;
    }
  }
}
